import { render, staticRenderFns } from "./SubmissionsOverview.vue?vue&type=template&id=0bb8c539&scoped=true&"
import script from "./SubmissionsOverview.vue?vue&type=script&lang=js&"
export * from "./SubmissionsOverview.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionsOverview.vue?vue&type=style&index=0&id=0bb8c539&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb8c539",
  null
  
)

export default component.exports